import { STATUS_META } from "@/lib/api";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, short = false, className = "" }) {
  const meta = STATUS_META[status] || STATUS_META.parado;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-2 border rounded-full px-3 py-1 text-xs font-semibold tracking-wide",
        meta.classes,
        className,
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", meta.dot)} />
      <span>{short ? meta.short : meta.label}</span>
    </span>
  );
}

export function StatusTimeline({ status }) {
  const steps = [
    { key: "parado", label: "Cadastro" },
    { key: "aguardando_aprovacao", label: "Aprovação" },
    { key: "em_andamento", label: "Em andamento" },
    { key: "pronto", label: "Pronto" },
    { key: "entregue", label: "Entregue" },
  ];
  const activeStep = STATUS_META[status]?.step || 1;
  if (status === "recusado") {
    return (
      <div data-testid="status-timeline" className="w-full rounded-lg border border-red-800 bg-red-950/40 px-3 py-2 text-sm font-semibold text-red-300">
        Orçamento recusado pelo cliente
      </div>
    );
  }
  if (status === "nao_realizado") {
    return (
      <div data-testid="status-timeline" className="w-full rounded-lg border border-red-900 bg-red-950/40 px-3 py-2 text-sm font-semibold text-red-300">
        Serviço não realizado — OS encerrada
      </div>
    );
  }
  return (
    <div data-testid="status-timeline" className="w-full">
      <div className="flex items-center gap-1 sm:gap-2">
        {steps.map((s, idx) => {
          const stepNum = idx + 1;
          const done = stepNum < activeStep;
          const current = stepNum === activeStep;
          return (
            <div key={s.key} className="flex-1 flex items-center gap-1 sm:gap-2 min-w-0">
              <div
                className={cn(
                  "flex items-center justify-center h-7 w-7 shrink-0 rounded-full border-2 text-[11px] font-bold font-mono",
                  done && "bg-green-brand text-black border-green-brand",
                  current && "bg-amber-brand text-black border-amber-brand animate-pulse",
                  !done && !current && "bg-zinc-900 text-zinc-500 border-zinc-700",
                )}
              >
                {stepNum}
              </div>
              {idx < steps.length - 1 && (
                <div
                  className={cn(
                    "h-0.5 flex-1 rounded-full",
                    stepNum < activeStep ? "bg-green-brand" : "bg-zinc-800",
                  )}
                />
              )}
            </div>
          );
        })}
      </div>
      <div className="flex items-center gap-1 sm:gap-2 mt-2">
        {steps.map((s, idx) => {
          const stepNum = idx + 1;
          const current = stepNum === activeStep;
          return (
            <div key={s.key} className="flex-1 text-center min-w-0">
              <span
                className={cn(
                  "text-[9px] sm:text-[10px] font-mono-caps truncate block",
                  current ? "text-amber-brand" : stepNum < activeStep ? "text-green-300" : "text-zinc-500",
                )}
              >
                {s.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
